import axios from 'axios';
import { USER_KEY } from '../helpers/constants';
import history from '../helpers/history';
import { AuthenthicatedUserInfo } from '../interfaces';
import { signout } from '../states/action_creators';
import store from '../states/store';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const apiCall = (setAuthorization: boolean = false) => {
  // Create instance
  let instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  if (setAuthorization) {
    // Set the AUTH token for any request
    instance.interceptors.request.use((config) => {
      const user: AuthenthicatedUserInfo = JSON.parse(localStorage.getItem(USER_KEY)!);
      const token = user['token'];
      config.headers!.Authorization = `Bearer ${token}`;
      return config;
    });
  }

  instance.interceptors.response.use(
    (config) => {
      return config;
    },
    async (error) => {
      if (error?.response?.status === 401) {
        store.dispatch(signout() as any);
      }
    }
  );

  return instance;
};
